import { userApiURL } from "API/urls/user.api";
import { axiosInstance } from "configs/axios";

export const resetPasswordApi = async ({ oldPassword, newPassword }) => {
  try {
    const response = await axiosInstance.post(userApiURL.resetPassword, {
      oldPassword,
      newPassword,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
